import React, { useContext } from 'react';
import { Store } from 'src/types';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  getGroupedPaymentProviders,
  getPaymentProviders,
} from 'src/components/store-payment/utils';
import { PaymentProviderLogotype, PaymentProviderMoreLabel } from './styles';
import { IPaymentProvider } from 'src/components/store-payment/types';

export const OfferPaymentProviders: React.FC<IPaymentProvidersProps> = ({
  store,
  showAll,
  limit,
}) => {
  const { market } = useContext(AppContext);
  const paymentProviders = getPaymentProviders(store, market);
  const providers = getGroupedPaymentProviders(store, market);
  let visibleProviders: IPaymentProvider[] = providers;

  if (limit && providers?.length > limit) {
    visibleProviders = providers.slice(0, limit);
  }

  const invisibleProviders: IPaymentProvider[] = paymentProviders.providers.filter(
    p => p.active && !visibleProviders.find(v => v.name === p.name)
  );
  return paymentProviders.hasProviders ? (
    <>
      {showAll &&
        paymentProviders.providers.map(
          provider =>
            Boolean(provider.active) && (
              <PaymentProviderLogotype
                src={provider.logoUrl}
                alt={provider.label}
                title={provider.label}
                key={provider.name}
              />
            )
        )}
      {!showAll &&
        visibleProviders.map(provider => (
          <PaymentProviderLogotype
            src={provider.logoUrl}
            alt={provider.label}
            title={provider.label}
            key={provider.name}
          />
        ))}
      {!showAll && invisibleProviders.length > 0 && (
        <PaymentProviderMoreLabel>
          <span>+</span>
          {invisibleProviders.length}
        </PaymentProviderMoreLabel>
      )}
    </>
  ) : null;
};

interface IPaymentProvidersProps {
  store: Store;
  showAll?: boolean;
  limit?: number;
}
